import { connect } from "react-redux";
import React from "react";
import { Icon, Message } from "semantic-ui-react";
import PropTypes from "prop-types";

import { accessStates } from "../VotifyPlayback/playbackCommands";
import { server } from "../../../config/vars";
import { PLAYBACK_TIMEOUT_S } from "../../../constants";

const getMessage = ({
  hasDevice,
  isAuthorized,
  accessState,
  isPlaybackTimeout,
}) => {
  if (!isAuthorized && isPlaybackTimeout) {
    return (
      <span>
        Spotbox is not authorized by Spotify. Please{" "}
        <a href={`${server.uri}/v1/auth/spotify`}>reauthorize</a>.
      </span>
    );
  } else if (!hasDevice && isPlaybackTimeout) {
    return "Spotbox has lost connection to the playlist. Check that the playing device is not in sleep mode.";
  } else if (accessState === accessStates.STOP) {
    return "Spotbox is currently not controlling the playlist.";
  }
};

const VotifyMessages = (props) => {
  const message = getMessage(props);
  return message ? (
    <Message error style={styles.message} icon>
      <Message.Item>
        <Icon name={"warning circle"} size={"large"} />
        <Message.Header content={getMessage(props)} />
      </Message.Item>
    </Message>
  ) : (
    ""
  );
};

VotifyMessages.propTypes = {
  hasDevice: PropTypes.bool.isRequired,
  isAuthorized: PropTypes.bool.isRequired,
  isPlaybackTimeout: PropTypes.bool.isRequired,
  accessState: PropTypes.string.isRequired,
};

const styles = {
  message: {
    backgroundColor: "black",
    color: "crimson",
    margin: 0,
    boxShadow: "0 0 0 1px red",
    display: "flex",
    alignItems: "center",
  },
};

const mapStateToProps = (state) => {
  return {
    hasDevice: state.host.hasDevice,
    isAuthorized: state.host.isAuthorized,
    accessState: state.playback.accessState,
    isPlaybackTimeout:
      !state.host.timeOfLastPlayback ||
      new Date() - state.host.timeOfLastPlayback > PLAYBACK_TIMEOUT_S * 1000,
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VotifyMessages);
